package blazern.lexisoup.domain.model

/**
 * @param start inclusive
 * @param end not inclusive
 */
data class TextAccent(
    val start: Int,
    val end: Int,
)
